import PropTypes from 'prop-types';

const modelShape = props => PropTypes.shape({
  _id: PropTypes.string,
  _created: PropTypes.string,
  _updated: PropTypes.string,
  ...props,
});

export const EpochType = PropTypes.shape({
  name: PropTypes.string,
  value: PropTypes.number,
});

export const RequestType = modelShape({
  guest_name: PropTypes.string,
  acting_user_full_name: PropTypes.string,
  epochs: PropTypes.arrayOf(EpochType),
  notify: PropTypes.bool,
  reservation_id: PropTypes.string,
  severity: PropTypes.string,
  label: PropTypes.string,
  source: PropTypes.string,
  is_immediate: PropTypes.bool,
  type: PropTypes.string,
  channel: PropTypes.string,
  delivery: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  affiliate_id: PropTypes.string,
  room: PropTypes.string,
  acting_user: PropTypes.string,
  status: PropTypes.string,
  assigned: PropTypes.string,
  body: PropTypes.any,
});

export const ChannelType = modelShape({
  dashboard_color: PropTypes.string,
  name: PropTypes.string,
  rank: PropTypes.number,
  label: PropTypes.string,
  affiliate_id: PropTypes.string,
  type: PropTypes.string,
});

export const ServiceConfigType = modelShape({
  weight: PropTypes.number,
  locale: PropTypes.string,
  service_name: PropTypes.string,
  service_label: PropTypes.string,
  service_icon: PropTypes.string,
  service_window: PropTypes.number,
  service_stop: PropTypes.string,
  service_start: PropTypes.string,
  description_long: PropTypes.string,
  description_short: PropTypes.string,
  channel: PropTypes.string,
  allow_comments: PropTypes.bool,
  max_comments: PropTypes.number,
  enabled: PropTypes.bool,
  display: PropTypes.bool,
});

export const RequestCardType = PropTypes.shape({
  channel: ChannelType,
  request: RequestType,
  serviceConfig: ServiceConfigType,
});



// WEBPACK FOOTER //
// ./src/views/requests/types.js